import getSessionStorageApi from 'api/browser/sessionstorage/get';
import setSessionStorageApi from 'api/browser/sessionstorage/set';
import { SESSIONSTORAGE } from 'constants/sessionStorage';

type ComponentImport = () => Promise<any>;

export const lazyRetry = (componentImport: ComponentImport): Promise<any> =>
	new Promise((resolve, reject) => {
		const hasRefreshed: boolean = JSON.parse(
			getSessionStorageApi(SESSIONSTORAGE.RETRY_LAZY_REFRESHED) || 'false',
		);

		componentImport()
			.then((component: any) => {
				setSessionStorageApi(SESSIONSTORAGE.RETRY_LAZY_REFRESHED, 'false');
				resolve(component);
			})
			.catch((error: Error) => {
				// A stale chunk reference right after a deploy self-heals: one reload pulls a
				// fresh index.html with the new hashed asset names. That reload is only
				// once-only if the flag persists, so a failed write (sessionStorage blocked in
				// an iframe, storage disabled) must not reload at all — it would loop forever.
				if (
					!hasRefreshed &&
					setSessionStorageApi(SESSIONSTORAGE.RETRY_LAZY_REFRESHED, 'true')
				) {
					window.location.reload();
				}

				reject(error);
			});
	});
